<template>
    <div v-if="stockGudang">
        <b-card class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 class="modal-title">Informasi Stock Gudang</h5>
            </b-card-header>
            <b-card-body>
                <table class="table table-borderless">
                    <tr>
                        <th>Gudang</th>
                        <td>:</td>
                        <th class="text-primary">{{ stockGudang.gudang ? stockGudang.gudang.name : '' }}</th>
                    </tr>
                    <tr>
                        <th>Tanggal</th>
                        <td>:</td>
                        <th class="text-primary">{{ now('DD MMMM YYYY') }}</th>
                    </tr>
                    <tr>
                        <th>Waktu</th>
                        <td>:</td>
                        <th class="text-primary">{{ now('HH:mm') }}</th>
                    </tr>
                    <tr>
                        <th>Grade</th>
                        <td>:</td>
                        <th class="text-primary">{{ stockGudang.grade ? stockGudang.grade.name : '' }}</th>
                    </tr>
                    <tr>
                        <th>Berat Total (kg)</th>
                        <td>:</td>
                        <th class="text-primary">{{ formatNumber(stockGudang.total_bobot) }}</th>
                    </tr>
                </table>

                <label class="form-control-label mt-3 pl-1">
                    Detail Barang
                </label>
                <div class="alert alert-primary mb-1" role="alert">
                    Total Barang : <strong class="text-nowrap">{{ formatNumber(pembelians.length) }}</strong>
                </div>
                <div class="table-responsive">
                    <table class="table">
                        <tr>
                            <th>No.</th>
                            <th>Kode</th>
                            <th>Berat</th>
                            <th>Tanggal Beli</th>
                            <th>Supplier</th>
                            <th></th>
                        </tr>
                        <tr v-for="(pembelian, index) in pembelians">
                            <th class="text-primary pl-0">
                                {{ index+1 }}
                            </th>
                            <th class="text-primary">{{ pembelian.code }}</th>
                            <th class="text-primary">{{ formatNumber(pembelian.latest_bobot) }} KG</th>
                            <th class="text-primary">{{ formatDate(pembelian.created_at) }}</th>
                            <th class="text-primary">{{ pembelian.supplier ? pembelian.supplier.name : pembelian.supply_mode }}</th>
                            <th class="fit-column text-center">
                                <button :disabled="isLoading" type="button" title="Print QrCode" @click="printQrCode(pembelian)" class="btn btn-link px-1"><i class="fas fa-print"></i></button>
                            </th>
                        </tr>
                    </table>
                </div>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <button :disabled="isLoading" @click="$emit('cancel')" type="button" class="btn btn-primary" data-dismiss="modal">OK</button>
                <button :disabled="isLoading" @click="print" type="button" class="btn btn-primary mr-2"><i class="fas fa-print"></i> Print</button>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import ExportMixin from '../../mixin/export';

export default {
    name: "stock-gudang-viewer",

    props: {
        value: {
            type: Object,
            default: null,
        }
    },

    components: {
    },

    mixins: [ExportMixin],

    data() {
        return {
            stockGudang: null,
            pembelians: [],
        }
    },

    created() {
    },

    mounted() {
        if (this.value) {
            this.stockGudang = Object.assign({}, this.value);
            this.loadPembelians();
        }
    },

    computed: {
        params() {
            return {
                gudang_id: this.stockGudang.gudang.id,
                grade_id: this.stockGudang.grade.id,
                status: this.stockGudang.status,
                tanggal: this.stockGudang.tanggal_action,
            };
        },
    },

    watch: {
        value() {
            this.stockGudang = Object.assign({}, this.value);
            this.loadPembelians();
        }
    },

    methods: {
        loadPembelians() {
            let self = this;

            self.isLoading = true;
            self.$Progress.start();
            axios.get('/api/stock-gudangs/details?' + self.convertParams(self.params))
            .then(function (response) {
                self.isLoading = false;
                self.$Progress.finish();
                self.pembelians = Object.assign([], response.data.data);
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },

        print() {
            let self = this;

            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            newIframe.src = '/stock-gudangs/print?'+self.convertParams(self.params);
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            }
        },

        printQrCode(data) {
            let self = this;
            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            newIframe.src = '/pembelian-tembakaus/print/' + data.id;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            }
        },
    },
}
</script>
<style>
.multiselect__placeholder {
    margin-bottom: 0;
}

th, td {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
}
</style>
